import { useEffect, useState } from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
import type { RequestProductsReport } from '@practium/features/api';
import styles from './ResponseTimeDailyChart.module.css';

interface ResponseTimeDailyChartProps {
	days: RequestProductsReport['responseTime']['days'];
}

export const ResponseTimeDailyChart = ({ days }: ResponseTimeDailyChartProps) => {
	const [primaryColor, setPrimaryColor] = useState('#453af1');
	const [tickColor, setTickColor] = useState('#767676');
	const data = days.map(day => ({
		...day,
		averageMinutes: day.averageMinutes ?? 0,
		label: new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit', timeZone: 'UTC' })
			.format(new Date(`${day.date}T00:00:00Z`)),
	}));

	useEffect(() => {
		const style = getComputedStyle(document.documentElement);
		const primary = style.getPropertyValue('--primary').trim();
		const secondary = style.getPropertyValue('--text-secondary').trim();
		if (primary) setPrimaryColor(primary);
		if (secondary) setTickColor(secondary);
	}, []);

	return (
		<div className={styles.chart}>
			<ResponsiveContainer width="100%" height="100%">
				<BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
					<CartesianGrid vertical={false} stroke="var(--border)" strokeDasharray="3 3" />
					<XAxis dataKey="label" axisLine={false} tickLine={false} tick={{ fill: tickColor, fontSize: 11 }} />
					<Tooltip
						labelFormatter={label => `Dia ${label}`}
						formatter={(value, _name, item) => [
							item.payload.count === 0 ? 'Sem respostas' : `${Number(value).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} min`,
							`Média (${item.payload.count} respostas)`,
						]}
						contentStyle={{ backgroundColor: 'var(--bg-surface)', borderColor: 'var(--border)', borderRadius: '0.5rem' }}
					/>
					<Bar dataKey="averageMinutes" name="Tempo médio" fill={primaryColor} radius={[4, 4, 0, 0]} maxBarSize={26} />
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};
